import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Accordion } from '@manulife/mux';
import { useRealm, useRichIntl, FormattedRichMessage, ContentPage } from 'ciam-self-service-shared';
import Page, { AUTH_TYPE } from '../../common/Page';
import AnalyticsDataLayer from '../../common/Analytics';
import {
  VERIFY_EMAIL_PAGE_NAME,
  VERIFY_EMAIL_PAGE_TITLE,
  VERIFIED_EMAIL_PAGE_NAME,
  EVENT_REGISTER_SUCCESS,
} from '../constants';
import SigninButton from '../../common/SigninButton';
import useAdobeAnalyticsRegistration from '../../../hooks/useAdobeAnalyticsRegistration';

const ParagraphWrapper = styled.div`
  padding: 2em 0;
`;

function SignUpVerifyPage(props) {
  const { firstName, isVerified, userName, ciamId } = props;
  const realm = useRealm();
  sessionStorage.setItem(`userName-${realm}`, userName);
  sessionStorage.setItem(`ciamId-${realm}`, ciamId);

  const richIntl = useRichIntl();

  const greeting = firstName ? `, ${firstName}` : '';

  const titleMessageId = !isVerified ? 'signupVerify.pending.page.title' : 'signupVerify.complete.page.title';
  const headingMessageId = !isVerified ? 'signupVerify.pending.page.heading' : 'signupVerify.complete.page.heading';
  useAdobeAnalyticsRegistration(isVerified);

  return (
    <Page
      title={richIntl.formatMessage({ id: titleMessageId }, { greeting })}
      authType={AUTH_TYPE.UNAUTHENTICATED}
      heading={richIntl.formatMessage(
        { id: headingMessageId },
        {
          greeting,
        },
      )}
    >
      <ContentPage heading={<FormattedRichMessage id={headingMessageId} values={{ greeting }} />}>
        {!isVerified ? (
          <>
            <AnalyticsDataLayer pageName={VERIFY_EMAIL_PAGE_NAME} ignoreSession />
            <ParagraphWrapper id="sent-email">
              <FormattedRichMessage id="signupVerify.pending.content" />
            </ParagraphWrapper>
            <Accordion
              title={richIntl.formatMessage({
                id: 'signupVerify.pending.why.title',
              })}
              customStyle={{
                titleStyle: { height: 'auto' },
                headerWrapperStyle: { alignItems: 'start' },
              }}
            >
              <FormattedRichMessage id="signupVerify.pending.why.content" />
            </Accordion>
            <ParagraphWrapper id="noemail">
              <FormattedRichMessage id="signupVerify.pending.noemail" />
            </ParagraphWrapper>
          </>
        ) : (
          <>
            <AnalyticsDataLayer pageName={VERIFIED_EMAIL_PAGE_NAME} pageTitle={VERIFY_EMAIL_PAGE_TITLE} ignoreSession />
            <AnalyticsDataLayer eventName={EVENT_REGISTER_SUCCESS} ignoreSession />
            <ParagraphWrapper>
              <FormattedRichMessage id="signupVerify.complete.content" />
            </ParagraphWrapper>
            <SigninButton isVerified />
          </>
        )}
      </ContentPage>
    </Page>
  );
}

SignUpVerifyPage.propTypes = {
  firstName: PropTypes.string.isRequired,
  isVerified: PropTypes.bool,
  userName: PropTypes.string,
  ciamId: PropTypes.string,
};

SignUpVerifyPage.defaultProps = {
  isVerified: false,
  userName: null,
  ciamId: null,
};

export default SignUpVerifyPage;
